import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Column from "../column"

const Grid = ({ blok, className }) => (
  <SbEditable content={blok}>
    <div
      className={`grid ${blok.gutters ? blok.gutters : className} ${
        blok.alignment ? blok.alignment : className
      }`}
    >
      {blok.columns &&
        blok.columns.map((col, idx) => (
          <Column
            key={col._uid}
            blok={col}
            className={`grid__col--${idx + 1}-${blok.columns.length}`}
          />
        ))}
    </div>
  </SbEditable>
)

Grid.defaultProps = {
  className: "",
}

Grid.propTypes = {
  blok: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.object),
    gutters: PropTypes.string,
    alignment: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
}

export default Grid
